import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    initialLoad: true,
    dashboardData: {},
  },
  mutations: {
    GET_DASHBOARD_DATA_START: (state) => {
      state.loading = true;
    },
    GET_DASHBOARD_DATA_FAILED: (state, error) => {
      state.loading = false;
      state.error = error;
    },
    GET_DASHBOARD_DATA_SUCCESS: (state, dashboardData) => {
      state.loading = false;
      (state.initialLoad = false), (state.dashboardData = dashboardData);
    },
  },
  actions: {
    async getDashboardData({ commit }) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_DASHBOARD_DATA_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/dashboard`,
          config
        );
        const data = await response.json();
        commit("GET_DASHBOARD_DATA_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_DASHBOARD_DATA_FAILED", err);
      }
    },
  },
};
